<template>
  <div class="theme-toggle" @click="toggleTheme">
    <el-tooltip :content="isDark ? '切换到浅色模式' : '切换到深色模式'" placement="bottom">
      <div class="toggle-btn" :class="{ 'is-dark': isDark }">
        <i :class="isDark ? 'el-icon-sunny' : 'el-icon-moon'"></i>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ThemeToggle',
  data () {
    return {
      isDark: false
    }
  },
  mounted () {
    // 从本地存储读取主题设置
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      this.isDark = savedTheme === 'dark'
      this.applyTheme()
    } else {
      // 检测系统偏好
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      this.isDark = prefersDark
      this.applyTheme()
    }
  },
  methods: {
    toggleTheme () {
      this.isDark = !this.isDark
      this.applyTheme()
      localStorage.setItem('theme', this.isDark ? 'dark' : 'light')
      this.$message.success(this.isDark ? '已切换到深色模式' : '已切换到浅色模式')
    },
    applyTheme () {
      if (this.isDark) {
        document.documentElement.setAttribute('data-theme', 'dark')
      } else {
        document.documentElement.removeAttribute('data-theme')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.theme-toggle {
  display: inline-block;

  .toggle-btn {
    width: 36px;
    height: 36px;
    border-radius: $border-radius-circle;
    background: var(--bg-white);
    border: 1px solid var(--border-light);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: $transition-base;

    i {
      font-size: $font-size-lg;
      color: var(--text-secondary);
      transition: $transition-base;
    }

    &:hover {
      border-color: $primary-color;
      box-shadow: 0 2px 8px rgba($primary-color, 0.2);

      i {
        color: $primary-color;
      }
    }

    &.is-dark {
      background: var(--bg-elevated);
      border-color: var(--border-light);

      i {
        color: #fbbf24;
      }

      &:hover {
        border-color: #fbbf24;
        box-shadow: 0 2px 8px rgba(251, 191, 36, 0.3);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ThemeToggle.vue